import { Mail } from "lucide-react";
import { Link } from "raviger";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";

type PrintEmailLinkButtonProps = {
  href: string;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  fullWidth?: boolean;
  basePath?: string;
};

const getEmailPrintHref = (href: string) => {
  const [path, hash = ""] = href.split("#");
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}email=1${hash ? `#${hash}` : ""}`;
};

export default function PrintEmailLinkButton({
  href,
  className,
  size,
  fullWidth,
  basePath,
}: PrintEmailLinkButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      size={size}
      className={cn(fullWidth && "w-full", className)}
      asChild
    >
      <Link
        href={getEmailPrintHref(href)}
        basePath={basePath}
        className={cn(fullWidth && "flex w-full items-center")}
      >
        <Mail className="size-4" />
        {t("email")}
      </Link>
    </Button>
  );
}
